export default {
    title: 'Zahlungsläufe',
    freetext: 'Freitext',
    serial_number: 'Maßnahmennummer',
    year: 'Jahr',
    status: 'Status',
    id: 'ID',
    event: 'Maßnahme',
    organisation: 'Organisation',
    fundingProgram: 'Förderprogramm',
    funding_program: 'Förderprogramm',
    period: 'Von - Bis',
    formProcesses: 'Formulare',
    subsidy_amount: 'Zuschusshöhe',
    intended_use: 'Verwendungszweck',
    sum: 'Gesamtbetrag',
    payments: 'Zahlungen',
    properties: 'Daten',
    documents: 'Dokumente',
    created_at: 'Erstellt am',

    qf_ownOnly: 'Nur eigene Maßnahmen'
}